module.exports = __webpack_public_path__ + "img/bell.92ea7b28.svg";